// extracted by mini-css-extract-plugin
export default {"light-text-color":"rgb(105, 111, 119)","noResults":"styles_noResults__pcRWZ"};